export default function BenefitsSection() {
  const benefits = [
    {
      icon: 'ri-timer-flash-line',
      title: 'Save Time',
      description: 'Skip endless scrolling. Find what you need in seconds with our organized spreadsheet product database.',
    },
    {
      icon: 'ri-scales-3-line',
      title: 'Compare Products',
      description: 'View multiple products side by side. Compare prices, quality, and features in one clean spreadsheet view.',
    },
    {
      icon: 'ri-search-eye-line',
      title: 'Discover Hidden Finds',
      description: 'Uncover rare and trending products that are buried in regular search results. Our spreadsheets surface the best hidden gems.',
    },
    {
      icon: 'ri-camera-lens-line',
      title: 'Review QC Photos',
      description: 'Every product comes with quality control photos so you can inspect items before making a purchase decision.',
    },
    {
      icon: 'ri-bar-chart-box-line',
      title: 'Track Products',
      description: 'Keep an organized record of products you are interested in, complete with notes, prices, and availability status.',
    },
  ];

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 lg:px-10">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold mb-4">
            Why Spreadsheet Shopping
          </span>
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-4">
            Why Use <strong className="font-heading font-normal text-primary-600">Spreadsheet Shopping</strong>?
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            The spreadsheet method transforms chaotic online shopping into a streamlined, efficient experience
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {benefits.map((benefit) => (
            <div
              key={benefit.title}
              className="group p-6 md:p-7 bg-white rounded-2xl border border-background-200/70 hover:border-accent-200 hover:shadow-sm transition-all duration-300 flex flex-col items-center text-center"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 rounded-2xl bg-accent-100 flex items-center justify-center mb-5 group-hover:bg-accent-200 transition-colors">
                <i className={`${benefit.icon} text-2xl md:text-3xl text-accent-600`}></i>
              </div>
              <h3 className="font-heading text-base md:text-lg text-foreground-900 mb-2">{benefit.title}</h3>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{benefit.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}